import React from 'react';
import Newspaper from '../Newspaper';

const NewspapersList = (props) => {
  let cont = 0;
  return (
    <div className="row">
      {props.newspapers.map((newspaper) => {
        if (typeof props.limit === 'undefined' || cont < props.limit) {
          cont++;
          return (
            <div key={newspaper.edition.id} className="col-sm-5 col-md-4 col-lg-3">
              <Newspaper
                newspaper={newspaper}
                key={newspaper.edition.id}
                noTitle={props.noTitle}
                noDate={props.noDate}
                linkToEdition={props.linkToEdition}
              />
            </div>
          );
        }
      })}
    </div>
  );
};

export default NewspapersList;



// WEBPACK FOOTER //
// ./src/components/NewspapersList/index.js